import { createSlice } from "@reduxjs/toolkit";

const requestDemoSlice = createSlice({
    name: "requestDemo",
    initialState: {
        showDemoRequest: false,
        isForDemo: true,
        price: {},
        isModalOpen: false
    },
    reducers: {
        toggleShowDemoRequest: (state, action) => {
            state.showDemoRequest = action.payload ?? !state.showDemoRequest;
        },
        setPrice: (state, action) => {
            state.price = action.payload;
        },
        setIsModalOpen: (state, action) => {
            state.isModalOpen = action.payload;
        }
    }
});

export const {
    toggleShowDemoRequest,
    setPrice,
    setIsModalOpen
} = requestDemoSlice.actions;

export default requestDemoSlice.reducer;
